import React, { type FunctionComponent } from 'react'
import { NavContainer } from 'gin-and-tonic/containers/nav/components/NavContainer'
import { AdminNavFooterContent } from 'gin-and-tonic/containers/nav/components/admin-nav/AdminNavFooterContent'
import { AdminNavMainContent } from 'gin-and-tonic/containers/nav/components/admin-nav/AdminNavMainContent'

export const AdminNavContent: FunctionComponent = () => (
  <NavContainer mainContent={<AdminNavMainContent />} footerContent={<AdminNavFooterContent />} />
)
